import {
    TOGGLE_SELECTED, SET_READY, SHOW_INLINE_ERROR, RESET_ERROR
} from 'constants/actionTypes/googlePay';
import decorators from 'utils/decorators';
import googlePayUtils from 'utils/GooglePay';
import OrderActions from 'actions/OrderActions';
import Actions from 'Actions';
import LanguageLocale from 'utils/LanguageLocale';
import GooglePayEN from 'utils/locales/GooglePay_en_US';
import GooglePayFR from 'utils/locales/GooglePay_fr_CA';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';

function toggleSelect(isSelected) {
    return {
        type: TOGGLE_SELECTED,
        isSelected
    };
}

function showInlineError(errorMessage) {
    return {
        type: SHOW_INLINE_ERROR,
        error: {
            errorMessage
        }
    };
}

function resetError() {
    return {
        type: RESET_ERROR
    };
}

function setReady(readyStatus) {
    return {
        type: SET_READY,
        isReady: readyStatus
    };
}

/**
 * Commits the Google Pay selection to the order's payment group on the
 * server so the choice is reflected in Cart/PS/Forter/order persistence and survives
 * a page refresh. Mirrors PazeActions.loadIframe: wraps the API call in an interstice,
 * updates the order on success, and surfaces a recoverable error modal on failure.
 * Re-throws on failure so the caller can gate the collapse-to-L1 handoff (AC3).
 */
const initializePaymentGroup =
    ({ orderId }) =>
        dispatch =>
            decorators
                .withInterstice(
                    googlePayUtils.initGooglePaymentGroup,
                    INTERSTICE_DELAY_MS
                )(orderId)
                .then(order => {
                    dispatch(OrderActions.updateOrder(order));

                    return order;
                })
                .catch(error => {
                    const getText = LanguageLocale.getLocalisedDataFromResource(GooglePayEN, GooglePayFR);

                    dispatch(Actions.showInterstice(false));
                    dispatch(setReady(false));
                    dispatch(
                        Actions.showInfoModal({
                            isOpen: true,
                            showCloseButton: true,
                            title: getText('googlePayErrorTitle'),
                            message: getText('googlePayRenderErrorMessage'),
                            buttonText: getText('googlePayErrorOkButton')
                        })
                    );
                    Sephora.logger.error('[GooglePay] initializePaymentGroup failed', error);

                    throw error;
                });

export default {
    toggleSelect,
    setReady,
    showInlineError,
    resetError,
    initializePaymentGroup
};
